<template>
    <div class="account">
        <Public></Public>

        <div class="account-content right-content">
            <div class="account-add">
                <div class="account-add-click">
                    <i class="el-icon-circle-plus-outline"></i>
                    <el-button class="button-text" type="text" @click="dialogFormVisible1 = true; MainTree()">添加管理员
                    </el-button>

                    <el-dialog title="添加管理员" width="6rem" :before-close="clearInfo" :visible.sync="dialogFormVisible1">
                        <el-form>
                            <el-form-item label="授权账号" :label-width="formLabelWidth">
                                <el-input v-model="account" placeholder="请输入授权账号" autocomplete="off"></el-input>
                            </el-form-item>
                            <el-form-item label="授权房源" :label-width="formLabelWidth">
                                <el-select placeholder="请选择房源" :value="selectHouseStr">
                                    <el-option :value="selectHouseStr">
                                        <el-tree show-checkbox @check="checkHouse" :data="maintree" ref="tree" :props="defaultProps"></el-tree>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="权限选择" :label-width="formLabelWidth">
                                <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
                                <div style="margin: 1px 0;"></div>
                                <el-checkbox-group v-model="checkedauthes" @change="CheckedAuthChange">
                                    <el-checkbox v-for="auth in authes" :label="auth" :key="auth">{{auth}}</el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                        </el-form>
                        <div slot="footer" class="dialog-footer">
                            <el-button @click="clearInfo()">取 消</el-button>
                            <el-button type="primary" @click="AddAuth()">确 认
                            </el-button>
                        </div>
                    </el-dialog>

                </div>
            </div>

            <div class="account-table">
                <el-table class="table-head" :data="accountdata" border style="width: 100%">
                    <el-table-column prop="Date" label="创建时间" width="110" sortable></el-table-column>
                    <el-table-column prop="AccountExec" label="授权账号" width="110"></el-table-column>
                    <el-table-column prop="Nick" label="昵称" width="110"></el-table-column>
                    <el-table-column label="权限" min-width="420">
                        <template slot-scope="scope">
                            <span v-html="scope.row.Authority.replace(/有/g,'<b style=\'color:#67C23A\'>有</b>')"></span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="150">
                        <template slot-scope="scope">
                            <el-button size="mini" type="primary" @click="dialogFormVisible2=true;handleEdit(scope.$index, scope.row)">编辑</el-button>
                            <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <el-dialog title="编辑授权" :before-close="clearInfo" width="6rem" :visible.sync="dialogFormVisible2">
                <el-form>
                    <el-form-item label="授权账号" :label-width="formLabelWidth">{{AccountExec}}</el-form-item>
                    <el-form-item label="当前房源" :label-width="formLabelWidth">
                        <!--<el-select placeholder="点击查看当前房源" value="">-->
                        <!--<el-option value="">-->
                        <div class="children-tree">
                            <el-tree :data="childrentree" :props="defaultProps"></el-tree>
                        </div>
                        <!--</el-option>-->
                        <!--</el-select>-->
                    </el-form-item>
                    <el-form-item label="授权房源" :label-width="formLabelWidth">
                        <el-select placeholder="请选择房源" :value="selectHouseStr">
                            <el-option :value="selectHouseStr">
                                <el-tree show-checkbox @check="checkHouse" :data="maintree" ref="tree" :props="defaultProps"></el-tree>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="权限选择" :label-width="formLabelWidth">
                        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
                        <div style="margin: 1px 0;"></div>
                        <el-checkbox-group v-model="checkedauthes" @change="CheckedAuthChange">
                            <el-checkbox v-for="auth in authes" :label="auth" :key="auth">{{auth}}</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="clearInfo()">取 消</el-button>
                    <el-button type="primary" @click="EditAuth()">确 认
                    </el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import Public from '@/views/Public.vue'
    import store from "../store";

    const authOptions = ['线下充值', '充值记录', '查看电表', '刷新令牌', '付费模式', '入住', '退房', '退房记录', '更改单价', '电表类型', '电表统计', '上报时间', '关闭权限', '电表抄表', '临时用电', '开启权限'];

    export default {
        name: "Account",
        components: {
            Public,
        },
        data() {
            return {
                select: 1,
                input: 1,
                accountdata: [],
                dialogFormVisible1: false,
                dialogFormVisible2: false,
                formLabelWidth: '1rem',
                checkAll: true,
                checkedauthes: authOptions,
                authes: authOptions,

                isIndeterminate: true,
                defaultProps: {
                    children: 'children',
                    label: 'label'
                },
                housedata: [],
                maintree: [],
                childrentree: [],
                AccountExec: '',
                Uuid: '',

                account: '',
                permissionHouses: {},
                oldDistrict: '',
                codes: [],
                districts: [],
                authData: {"1":1,"2":1,"3":1,"4":1,"5":1,"6":1,"7":1,"8":1,"9":1,"10":1,"11":1,"12":1,"13":1,"14":1,"16":1,"17":1},
                authStrArr: [],
                selectHouses: [],
                selectHouseStr: '',
                isSelectClick: false,
            }
        },
        mounted: function () {
            this.GetAccountExec();
        },
        methods: {
            clearInfo() {
                this.dialogFormVisible1 = false;
                this.dialogFormVisible2 = false;
                this.permissionHouses = {};
                this.selectHouseStr = '';
                this.checkedauthes = authOptions;
                this.AccountExec='';
                this.Uuid='';
                this.authData = {"1":1,"2":1,"3":1,"4":1,"5":1,"6":1,"7":1,"8":1,"9":1,"10":1,"11":1,"12":1,"13":1,"14":1,"16":1,"17":1};
                this.checkAll = true;
                this.isSelectClick = false;
            },
            GetAccountExec() {
                if (window.localStorage.isChild == 1) {
                    this.$router.push('/house');
                } else {
                    this.$http.get(`${store.state.url}zone/permissions/${window.localStorage.userid}?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                        .then((res) => {
                            if (res.Code == 0) {
                                let accountdata = [];
                                for (let i in res.Data) {
                                    let msg = '';
                                    let msgtemp;
                                    msg += JSON.stringify(res.Data[i].Perms);
                                    msgtemp = msg.replace("\"1\"", "【线下充值");
                                    msgtemp = msgtemp.replace("\"2\"", "【充值记录");
                                    msgtemp = msgtemp.replace("\"3\"", "【查看电表");
                                    msgtemp = msgtemp.replace("\"4\"", "【刷新令牌");
                                    msgtemp = msgtemp.replace("\"5\"", "【付费模式");
                                    msgtemp = msgtemp.replace("\"6\"", "【入住");
                                    msgtemp = msgtemp.replace("\"7\"", "【退房");
                                    msgtemp = msgtemp.replace("\"8\"", "【退房记录");
                                    msgtemp = msgtemp.replace("\"9\"", "【更改单价");
                                    msgtemp = msgtemp.replace("\"10\"", "【电表类型");
                                    msgtemp = msgtemp.replace("\"11\"", "【电表统计");
                                    msgtemp = msgtemp.replace("\"12\"", "【上报时间");
                                    msgtemp = msgtemp.replace("\"13\"", "【关闭权限");
                                    msgtemp = msgtemp.replace("\"14\"", "【电表抄表");
                                    msgtemp = msgtemp.replace("\"15\"", "【申请提现");
                                    msgtemp = msgtemp.replace("\"16\"", "【临时用电");
                                    msgtemp = msgtemp.replace("\"17\"", "【开启权限");
                                    msgtemp = msgtemp.replace(/:1/g, "：有】");
                                    msgtemp = msgtemp.replace(/:0/g, "：无】");
                                    msgtemp = msgtemp.replace("{", "");
                                    msgtemp = msgtemp.replace("}", "");

                                    accountdata[i] = {
                                        Date: res.Data[i].Addtime,
                                        AccountExec: res.Data[i].Userid,
                                        Nick: res.Data[i].Nick,
                                        Authority: msgtemp,
                                        Uuid: res.Data[i].Uuid
                                    }
                                }
                                this.accountdata = accountdata;
                            } else {
                                this.$message(res.Message);
                            }
                        })
                }
            },
            Housedata(userid) {
                return new Promise((resolve, reject) => {
                    this.$http.get(`${store.state.url}zone/tree/` + userid + `?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                        .then((res) => {
                            if (res.Code == 0) {
                                var housedata = [];
                                var data = res.Data;
                                for (let i in data) {
                                    housedata[i] = {
                                        label: data[i].Title,
                                        children: [],
                                        zoneid: data[i].Zoneid,
                                        district: data[i].Districtcode,
                                        code: data[i].Code
                                    };
                                    if (data[i].Children != null) {
                                        for (let j in data[i].Children) {
                                            housedata[i].children[j] = {
                                                label: data[i].Children[j].Title,
                                                children: [],
                                                zoneid: data[i].Children[j].Zoneid,
                                                district: data[i].Children[j].Districtcode,
                                                code: data[i].Children[j].Code
                                            };

                                            let villages = data[i].Children[j].Children
                                            if (villages != null) {
                                                for (let k in villages) {
                                                    housedata[i].children[j].children[k] = {
                                                        label: villages[k].Title,
                                                        children: [],
                                                        zoneid: villages[k].Zoneid,
                                                        district: villages[k].Districtcode,
                                                        code: villages[k].Code
                                                    };

                                                    if (villages[k].Children != null) {
                                                        for (let q in villages[k].Children) {
                                                            housedata[i].children[j].children[k].children[q] = {
                                                                label: villages[k].Children[q].Title,
                                                                children: [],
                                                                zoneid: villages[k].Children[q].Zoneid,
                                                                district: villages[k].Children[q].Districtcode,
                                                                code: villages[k].Children[q].Code
                                                            };

                                                            let floors = villages[k].Children[q].Children
                                                            if (floors != null) {
                                                                for (let p in floors) {
                                                                    housedata[i].children[j].children[k].children[q].children[p] = {
                                                                        label: floors[p].Title,
                                                                        children: [],
                                                                        zoneid: floors[p].Zoneid,
                                                                        district: floors[p].Districtcode,
                                                                        code: floors[p].Code
                                                                    }

                                                                    if (floors[p].Children != null) {
                                                                        for (let t in floors[p].Children) {
                                                                            housedata[i].children[j].children[k].children[q].children[p].children[t] = {
                                                                                label: floors[p].Children[t].Title,
                                                                                children: [],
                                                                                zoneid: floors[p].Children[t].Zoneid,
                                                                                district: floors[p].Children[t].Districtcode,
                                                                                code: floors[p].Children[t].Code
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                                resolve(housedata);
                            } else {
                                this.$message(res.Message);
                            }
                        })
                })
            },

            MainTree() {
                if (this.maintree != []) {
                    var userid = window.localStorage.userid;
                    this.Housedata(userid).then((housedata) => {
                        this.maintree = housedata;
                    });
                }
            },
            ChildrenTree(userid) {
                this.Housedata(userid).then((housedata) => {
                    this.childrentree = housedata;
                });
            },

            handleCheckAllChange(val) {
                this.checkedauthes = val ? authOptions : [];
                this.isIndeterminate = false;
                this.isSelectClick = true;
                this.authStrArr = this.checkedauthes;
            },
            CheckedAuthChange(value, b) {
                this.isSelectClick = true;
                let checkedCount = value.length;
                this.checkAll = checkedCount === this.authes.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.authes.length;
                this.authStrArr = value;
            },
            checkHouse() {
                console.log('a',this.$refs.tree.getCheckedNodes(true, false))
                this.selectHouses = [];
                this.districts = [];
                let selectedNodes = this.$refs.tree.getCheckedNodes(true, false);
                //房源有code,房源上级无code
                for (let node of selectedNodes) {
                    let district = node.district,
                        code = node.code,
                        zoneid = node.zoneid;
                    if (code == '') {
                        let index = this.districts.indexOf(district);
                        if (index < 0) {
                            this.districts.push(district);
                            this.selectHouses.push(node.label);
                        } else {
                            this.districts.splice(index, 1);
                            let labelIndex = this.selectHouses.indexOf(node.label);
                            this.selectHouses.splice(labelIndex, 1);
                        }
                    } else {
                        this.codes = [];
                        this.codes.push(code);
                        this.permissionHouses[district] = this.codes;
                        this.selectHouses.push(node.label);
                    }
                }
                this.selectHouseStr = "";
                for (let houseLabel of this.selectHouses) {
                    this.selectHouseStr += houseLabel + " ";
                }
            },
            confirmAuth() {
                if (this.isSelectClick == true) {
                    for (let auth in this.authData) {
                        this.authData[auth] = 0;
                    }
                    for (let val of this.authStrArr) {
                        switch (val) {
                            case '线下充值':
                                console.log(val)
                                this.authData["1"] = 1;
                                break;
                            case '充值记录':
                                this.authData["2"] = 1;
                                break;
                            case '查看电表':
                                this.authData["3"] = 1;
                            case '刷新令牌':
                                this.authData["4"] = 1;
                                break;
                            case '付费模式':
                                this.authData["5"] = 1;
                                break;
                            case '入住':
                                this.authData["6"] = 1;
                                break;
                            case '退房':
                                this.authData["7"] = 1;
                                break;
                            case '退房记录':
                                this.authData["8"] = 1;
                                break;
                            case '更改单价':
                                this.authData["9"] = 1;
                                break;
                            case '电表类型':
                                this.authData["10"] = 1;
                                break;
                            case '电表统计':
                                this.authData["11"] = 1;
                                break;
                            case '上报时间':
                                this.authData["12"] = 1;
                                break;
                            case '关闭权限':
                                this.authData["13"] = 1;
                                break;
                            case '电表抄表':
                                this.authData["14"] = 1;
                                break;
                            // case '申请提现':
                            //     this.authData["15"] = 1;
                            //     break;
                            case '临时用电':
                                this.authData["16"] = 1;
                                break;
                            case '开启权限':
                                this.authData["17"] = 1;
                                break;
                        }
                    }
                }
            },

            AddAuth() {
                console.log('fsdfds')
                this.confirmAuth();
                this.$http({
                    method: 'post',
                    url: `${store.state.url}permission?uid=${window.localStorage.uid}&token=${window.localStorage.token}`,
                    data: {
                        // {"0502080001":["0000000002"],"09010b074d":["0050010001"]}
                        "Userid": this.account,
                        "Permissions": this.authData,
                        "Houses": this.permissionHouses,
                        "Districts": this.districts,
                    }
                })
                    .then((res) => {
                        if (res.Code == 0) {
                            this.$message('添加成功');
                            this.dialogFormVisible1 = false;
                            this.account = '';
                            this.selectHouseStr = '';
                            this.authData = {"1":1,"2":1,"3":1,"4":1,"5":1,"6":1,"7":1,"8":1,"9":1,"10":1,"11":1,"12":1,"13":1,"14":1,"16":1,"17":1};
                            this.isSelectClick = false;
                            this.checkedauthes = authOptions;
                            this.GetAccountExec();
                        } else {
                            this.$message.error(res.Message);
                        }
                    });
            },

            EditAuth() {
                this.confirmAuth();
                this.$http({
                    method: 'put',
                    url: `${store.state.url}permission/` + this.Uuid + `?uid=${window.localStorage.uid}&token=${window.localStorage.token}`,
                    data: {
                        "Uuid": this.Uuid,
                        "Userid": this.AccountExec,
                        "Permissions": this.authData,
                        "Houses": this.permissionHouses,
                        "Districts": this.districts,
                    }
                })
                    .then((res) => {
                        if (res.Code == 0) {
                            this.$message('编辑成功');
                            this.dialogFormVisible2 = false;
                            this.account = '';
                            this.selectHouseStr = '';
                            this.authData = {"1":1,"2":1,"3":1,"4":1,"5":1,"6":1,"7":1,"8":1,"9":1,"10":1,"11":1,"12":1,"13":1,"14":1,"16":1,"17":1};
                            this.isSelectClick = false;
                            this.checkedauthes = authOptions;
                            this.AccountExec = '';
                            this.Uuid = '';
                            this.GetAccountExec();
                        } else {
                            this.$message.error(res.Message);
                        }
                    });
            },

            handleEdit(index, row) {
                this.AccountExec = row.AccountExec;
                this.Uuid = row.Uuid;
                this.ChildrenTree(row.AccountExec);
                this.MainTree();
            },

            handleDelete(index, row) {
                this.$confirm('您确定要删除当前配置权限?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(() => {
                    this.$http.delete(`${store.state.url}permission/` + row.Uuid + `?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                        .then((res) => {
                            if (res.Code == 0) {
                                this.GetAccountExec();
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                            } else {
                                this.$message.error(res.Message);
                            }
                        });

                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
        }

    }
</script>

<style scoped>
    .account {
        height: 100%;
    }

    .account-content {
        margin: 0.1rem;
    }

    .account-add {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding-left: 0.1rem;
        font-size: 0.17rem;
        margin: 0.1rem;
    }

    .account-add i {
        color: #409EFF;
        margin-right: 0.04rem;
    }

    .account-add-click {

    }

    .el-form-item {
        width: 5rem;
    }

    .account-add-click .button-text {
        font-size: 18px;
    }

    .account-add-click .el-form {
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
    }

    .choose-house {

    }

    .account-add .search-input {
        width: 90%;
        padding-right: 0.06rem;
    }

    .right-content .account-table {
        margin: 0 0.3rem 1rem 0.15rem;
    }

    .el-select-dropdown__item {
        height: 2.3rem;
        overflow-y: scroll;
    }

    li.el-select-dropdown__item.hover {
        background-color: white;
    }

    .el-form-item .el-select {
        width: 100%;
    }

    .children-tree{
        font-size:14px;
        max-height:2rem;
        overflow-y: scroll;
    }

    /*::-webkit-scrollbar {!*滚动条整体样式*!*/
    /*width: 7px;     !*高宽分别对应横竖滚动条的尺寸*!*/
    /*height: 7px;*/
    /*}*/
    /*::-webkit-scrollbar-thumb {!*滚动条里面小方块*!*/
    /*border-radius: 10px;*/
    /*-webkit-box-shadow: inset 0 0 5px rgba(135, 135, 135, 0.2);*/
    /*background: #dfdfdf;*/
    /*}*/
    /*::-webkit-scrollbar-track {!*滚动条里面轨道*!*/
    /*-webkit-box-shadow: inset 0 0 5px rgba(205, 205, 205, 0.2);*/
    /*border-radius: 10px;*/
    /*background: #f6f6f6;*/
    /*}*/

    .el-checkbox {
        margin-left: 0;
        width: 92px;
    }

    /*.account-table .el-table__body-wrapper {*/
    /*height:80vh !important;*/
    /*overflow-y: auto;*/
    /*}*/


</style>
